const getRadianAngle = (degreeValue: number) => (degreeValue * Math.PI) / 180

export default getRadianAngle
